<template>
  <img v-if="url" :src="url" alt="" :style="`width: ${w};height: ${w};`" />
  <span v-else class="platform-placeholder" :style="`width: ${w};height: ${w};`">{{ firstChar }}</span>
</template>
<script>
let platforms = localStorage.getItem('platforms')
platforms = platforms ? JSON.parse(platforms) : []

export default {
  name: 'PlatformImg',
  props: {
    code: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    w: {
      type: String,
      default: '25px'
    }
  },
  computed: {
    url() {
      const obj = platforms.find((item) => item.code === this.code)
      return obj ? obj.logo_url : ''
    },
    firstChar() {
      return this.name ? this.name.charAt(0) : ''
    }
  }
}
</script>
<style scoped>
.platform-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #ff3176;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
}
</style>
